import { Swiper, Navigation } from '@hh/global.js'

class HHVariantSwatches extends HTMLElement {
  constructor() {
    super()
    Swiper.use([Navigation])

    this.section = this.closest('.js-product-section')

    this.sliderInited = false
    this.device = this.getDeviceType()
    window.addEventListener('resize', () => {
      const device = this.getDeviceType()
      if (device != this.device) {
        this.device = device
        this.toggleSlider()
      }
    })
    this.swatches = this.querySelectorAll('.js-swatch-item')
    this.toggleSlider()

    this.groups = this.querySelectorAll('.js-variant-group')

    this.groups.forEach(group => {
      group.addEventListener('click', (event) => {
        this.changeVariantGroup(group)
      })
    })

    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', (event) => {
        this.selectSwatch(swatch)
      })
    })

    this.addEventListener('SWATCH_CHANGE', this.onSwatchChanged.bind(this))
  }

  toggleSlider () {
    if (this.device == 'mobile') {
      const centeredSlider = this.swatches.length > 8
      this.swiperSlider = new Swiper(this.querySelector('.js-slider'), {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: centeredSlider,
        centeredSlidesBounds: centeredSlider,
        navigation: {
          nextEl: this.querySelector('.js-next'),
          prevEl: this.querySelector('.js-prev'),
        }
      })

      this.sliderInited = true
    } else if (this.swiperSlider && this.sliderInited) {
      this.swiperSlider.destroy( true, true )
    }
  }

  getDeviceType () {
    return (window.innerWidth >= 750) ? 'desktop' : 'mobile'
  }

  onSwatchChanged(e) {
    if (!e.detail?.id) return
    const id = e.detail.id

    this.selectSwatch(this.querySelector(`.js-swatch-item[data-id="${id}"]`), false)

    var elements = document.querySelectorAll(".js-swatch-item:not(.hidden)");

    var indexOfActiveElement = -1;

    for (var i = 0; i < elements.length; i++) {
      if (elements[i].classList.contains("active")) {
        indexOfActiveElement = i;
        break;
      }
    }
    if(!this.swiperSlider) {
      return
    }
    if (indexOfActiveElement !== -1) {
      this.swiperSlider.slideTo(indexOfActiveElement)
    }
  }

  getOptionTpl (id, title) {
    if (id && title) return `<option value="${id}">${title}</option>`
  }

  toggleDropdownProductFormItems (productFormSelector, groupSwatch) {
    const productForm = document.querySelector(productFormSelector)
    if (productForm) {
      const productFormItems = productForm.querySelectorAll('.js-product-form-item')
      if (productFormItems.length > 0) {
        productFormItems.forEach((formItem) => {
          const formItemGroup = formItem.dataset.variantGroup

          if (formItemGroup == groupSwatch || groupSwatch == 'all') {
            formItem.classList.remove('product-form__variant-item--list-item-hidden')
          } else {
            formItem.classList.add('product-form__variant-item--list-item-hidden')
          }
        })
      }
    }
  }

  changeVariantGroup(group) {
    if (group.classList.contains('active')) return

    const groupSwatch = group.getAttribute('data-group')
    let firstActiveSwatch
    let swatchOptionsTpl = ''

    this.groups.forEach(groupItem => {
      if (groupItem == group) {
        groupItem.classList.add('active')
      } else {
        groupItem.classList.remove('active')
      }
    })

    this.swatches.forEach(swatch => {
      const swatchGroup = swatch.getAttribute('data-group')

      if (swatchGroup == groupSwatch || groupSwatch == 'all') {
        swatch.classList.remove('hidden')
        swatchOptionsTpl += this.getOptionTpl(swatch.getAttribute('data-id'), swatch.getAttribute('title'))
        if (!firstActiveSwatch) firstActiveSwatch = swatch
      } else {
        swatch.classList.add('hidden')
      }
    })

    this.toggleDropdownProductFormItems('.product-form__variants', groupSwatch)

    this.section?.querySelectorAll('.js-product-variants').forEach(select => {
      select.innerHTML = swatchOptionsTpl
    })

    if (firstActiveSwatch) this.selectSwatch(firstActiveSwatch)
  }

  selectDropdownProductFormItem (productFormSelector, swatch) {
    const productForm = document.querySelector(productFormSelector)
    if (productForm) {
      const newId = swatch.dataset.id
      const productFormItems = productForm.querySelectorAll('.js-product-form-item')
      if (productFormItems.length > 0) {
        productFormItems.forEach((formItem) => {
          const formItemId = formItem.dataset.variantId
          if (formItemId === newId) {
            formItem.classList.add('product-form__variant-item--list-item-selected')

            const productFormList = formItem.parentElement
            if (productFormList && formItem) {
              productFormList.scrollTop = formItem.offsetTop - productFormList.offsetTop;
            }
  
            const currentProductFormItems = productForm.querySelectorAll(`[data-current-variant-id]`)
            if (currentProductFormItems.length > 0) {
              currentProductFormItems.forEach((currentFormItem) => {
                currentFormItem.dataset.currentVariant = newId

                const currentFormItemTitle = currentFormItem.querySelector('[data-current-title]')
                currentFormItemTitle.innerHTML = formItem.dataset.variantTitle

                const currentFormItemIcon = currentFormItem.querySelector('[data-current-icon]')
                currentFormItemIcon.setAttribute('style', formItem.dataset.variantIconStyle);
                
                if (formItem.dataset.variantIsDisabled === 'true') {
                  currentFormItem.classList.add('product-form__variant-item--list-item-disabled')
                } else {
                  currentFormItem.classList.remove('product-form__variant-item--list-item-disabled')
                }
              })
            }
          } else {
            formItem.classList.remove('product-form__variant-item--list-item-selected')
          }
        })
      }
    }
  }

  selectSwatch (swatch, triggerSelector = true) {
    if (!swatch || swatch.classList.contains('active')) return

    this.swatches.forEach(swatchItem => {
      if (swatchItem == swatch) {
        swatchItem.classList.add('active')
        this.selectDropdownProductFormItem('.product-form__variants', swatch)
      } else {
        swatchItem.classList.remove('active')
      }
    })

    this.querySelectorAll('.js-active-variant-title').forEach(titleElement => {
      titleElement.innerHTML = swatch.getAttribute('data-option-title')
    })

    this.section?.querySelectorAll('.js-product-media').forEach(media => {
      media.dispatchEvent(new CustomEvent('SWATCH_IMAGES_CHANGE', {
        detail: {
          handle: swatch?.getAttribute('data-option-title-handle')
        }
      }))
    })

    const isLowStock = (swatch?.getAttribute('data-low-stock') == 'true')
    this.section?.querySelectorAll('.js-low-stock-message').forEach(element => {
      if (isLowStock) {
        element.classList.add('show')
      } else {
        element.classList.remove('show')
      }
    })

    const price = swatch?.getAttribute('data-price')
    const comparePrice = swatch?.getAttribute('data-compare-price')
    const isSoldOut = swatch?.classList.contains('disabled')
    if (price) {
      this.section?.querySelectorAll('.js-variant-price').forEach(element => {
        element.innerHTML = price
      })
      this.section?.querySelectorAll('.js-variant-compare-price').forEach(element => {
        element.innerHTML = comparePrice
      })

      this.section?.querySelectorAll('.js-variant-price-wrapper').forEach(element => {
        if (comparePrice && comparePrice != price) {
          element.classList.add('product-price__sale')
        } else {
          element.classList.remove('product-price__sale')
        }
      })
    }

    this.section?.querySelectorAll('.js-variant-availability').forEach(element => {
      let soldOutLabel = element.getAttribute('data-sold-out-txt')
      const atcLabel = element.getAttribute('data-add-to-cart')
      const variantId = swatch.getAttribute('data-id')

      const rawData = document.querySelector('.js-variant-msgs')
      const data = JSON.parse(rawData.innerText)

      data.variants.forEach((variant) => {
        if(Number(variant.id) == variantId){
          if(variant.text !== null){
            soldOutLabel = variant.text
          }
        }
      })

      if (isSoldOut) {
        element.innerHTML = soldOutLabel
      } else {
        element.innerHTML = atcLabel
      }
    })

    const id = swatch?.getAttribute('data-id')
    this.section?.querySelectorAll('.js-variant-detail').forEach(element => {
      if (element.getAttribute('data-id') == id) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })

    if (!triggerSelector) return
    this.section?.querySelectorAll('.js-product-variants').forEach(select => {
      select.value = swatch?.getAttribute('data-id')
      select.dispatchEvent(new CustomEvent('change', {
        detail: {
          id: swatch?.getAttribute('data-id')
        },
        bubbles: true
      }))
    })
    if(!this.swiperSlider) {
      return
    }
    
    this.swiperSlider.slideTo(this.swiperSlider.clickedIndex)
  }
}

customElements.define('hh-variant-swatches', HHVariantSwatches)
